import styled from 'styled-components';

import { Text1, Button } from 'app/shared/ui';

export const ImageWrapperSt = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SuccessTextSt = styled(Text1)`
  margin-bottom: 32px;
  text-align: left;
  font-weight: bold;
`;

export const ButtonSt = styled(Button)`
  font-size: 16px;
  font-weight: 500;
`;
